import { withInstall } from "../utils";
import _Sidebar from "./Sidebar";
const Sidebar = withInstall(_Sidebar);
var stdin_default = Sidebar;
export {
  Sidebar,
  stdin_default as default
};
